/* JG Idyl v2 nav (3 Oct 2026). Spec: nav_gap/gap_spec.md section 2.
   1. Desktop mega menu opens on hover and closes when the pointer leaves the label and its panel. Only on hover-capable fine pointers.
      Click (touch) and keyboard keep Dawn's native details toggle.
   2. Phone drawer is one flat list of inline accordions. Dawn drills in (slides a sub-panel over the list and traps focus there),
      so nested summaries here only use the native details toggle. The first group (SHOP) opens every time the drawer opens.
   Loaded with defer after global.js and details-disclosure.js. */
(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function setExpanded(details, open) {
    var summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  onReady(function () {
    /* ---------- 1. desktop mega menu ---------- */
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    var menus = Array.prototype.slice.call(document.querySelectorAll('.header__inline-menu header-menu'));

    menus.forEach(function (hm) {
      var details = hm.querySelector('details');
      var summary = details && details.querySelector('summary');
      if (!details || !summary) return;
      var closeTimer = null;
      var hoverOpened = false;

      function open() {
        if (details.open) return;
        details.setAttribute('open', '');
        setExpanded(details, true);
      }
      function close() {
        if (!details.open) return;
        details.removeAttribute('open');
        setExpanded(details, false);
      }

      hm.addEventListener('mouseenter', function () {
        if (!fine.matches) return;
        window.clearTimeout(closeTimer);
        menus.forEach(function (other) {
          if (other === hm) return;
          var od = other.querySelector('details');
          if (od && od.open) {
            od.removeAttribute('open');
            setExpanded(od, false);
          }
        });
        if (!details.open) {
          hoverOpened = true;
          open();
        }
      });

      hm.addEventListener('mouseleave', function () {
        if (!fine.matches) return;
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(function () {
          if (hoverOpened) {
            hoverOpened = false;
            close();
          }
        }, 120);
      });

      /* a mouse click on a label that hover already opened keeps the panel open instead of toggling it shut.
         e.detail is 0 for keyboard activation, so Enter and Space still toggle. */
      summary.addEventListener('click', function (e) {
        if (fine.matches && hoverOpened && details.open && e.detail > 0) e.preventDefault();
      });

      details.addEventListener('toggle', function () {
        if (!details.open) hoverOpened = false;
      });
    });

    /* ---------- 2. phone drawer ---------- */
    var drawer = document.querySelector('header-drawer');
    if (!drawer) return;
    var main = drawer.querySelector('#Details-menu-drawer-container');
    if (!main) return;
    var nested = Array.prototype.slice.call(main.querySelectorAll('.menu-drawer__navigation details'));

    /* Capture phase on the drawer runs before Dawn's listener on the summary itself.
       Stopping propagation there keeps Dawn's drill-in out of the way, the native toggle still happens. */
    drawer.addEventListener(
      'click',
      function (e) {
        var summary = e.target.closest ? e.target.closest('summary') : null;
        if (!summary) return;
        var details = summary.parentElement;
        if (!details || details === main || !main.contains(details)) return;
        e.stopPropagation();
      },
      true
    );

    nested.forEach(function (d) {
      setExpanded(d, d.open);
      d.addEventListener('toggle', function () {
        setExpanded(d, d.open);
      });
    });

    /* Dawn removes open from every nested group when the drawer closes. Put SHOP back on the next open. */
    if (nested.length) {
      main.addEventListener('toggle', function () {
        if (main.open) {
          nested[0].setAttribute('open', '');
          setExpanded(nested[0], true);
        }
      });
    }
  });
})();
